import classNames from 'classnames';

import styles from './ProfileCircle.module.scss';

type ProfileCircleProps = {
  src: string;
  alt: string;
  className?: string;
};

const ProfileCircle = ({ src, alt, className }: ProfileCircleProps) => <img className={classNames(styles.profileIcon, className)} src={src} alt={alt} />;

export default ProfileCircle;
